import { createContext, useContext } from 'react';

export const PermissionsContext = createContext({});

/**
 * usePermissions() — access the current user's feature permission flags.
 *
 * Usage:
 *   const perms = usePermissions();
 *   if (perms.show_expired_customers !== false) { ... }
 *
 * A missing key always means "enabled" (true). Only an explicit false disables a feature.
 * Admin users always receive an empty object, so all checks pass through.
 */
export const usePermissions = () => useContext(PermissionsContext);
